"use strict";
/**
 * calcMaxlinumModule Module
 * create by lileilei
 * on 2017-12-7
 * Description 稿件背景的标签每部分默认显示两行 用于计算多少个标签可以撑满两行
 */
angular.module('calcMaxlinumModule', []).directive('calcMaxlinum', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

    return {
        restrict: 'A',
        scope: {
            maxLinum: "="
        },
        link: function(scope, elem, attr) {
            var maxNum;
            var num = 0;
            var maxWidth = 0;
            initstatus();

            function initstatus() {
                $timeout(function() {
                    var liLen = ($(elem).find("li").length - 1) / 2;
                    var elemWidth = $(elem).find("ul").outerWidth();
                    if (liLen > 1) { //等待页面渲染完成 li全部加载出来
                        // maxWidth = maxWidth + $(elem).find("ul li:last-child").outerWidth() + 10;
                        jisuanli(num);

                        function jisuanli(num) { //循环加上li的宽度和margin-left总宽度大于td的宽度x2时停止相加，得出大于宽度之前的li数量
                            maxWidth += $(elem).find("ul li:eq(" + num + ")").outerWidth() + 10;
                            if (num >= liLen) {
                                maxNum = num ;
                                if (maxNum && attr['maxLinum']) {
                                    scope.maxLinum = maxNum;
                                }
                                return;
                            }
                            if (maxWidth < elemWidth) {
                                if (maxWidth + $(elem).find("ul li").eq(num+1).outerWidth() + 10 > elemWidth) {
                                    scope.firstRowlinum = angular.copy(num);
                                }
                                num++;
                                jisuanli(num); //继续相加li的宽度
                            } else {
                                var secondWidth = $(elem).find("ul li:last-child").outerWidth() + 10;
                                var num2 = 0;
                                jisuanSecondWidth(num2);
                                function jisuanSecondWidth(num2) {
                                    secondWidth += $(elem).find("ul li").eq(num+num2).outerWidth() + 10;
                                    if (secondWidth < elemWidth) {
                                        num2++;
                                        jisuanSecondWidth(num2);
                                    } else {
                                        maxNum = scope.firstRowlinum + num2 + 1;
                                        if (maxNum && attr['maxLinum']) {
                                            scope.maxLinum = maxNum;
                                        }
                                        return;
                                    }
                                }
                            } 
                        }
                    } else {
                        initstatus();
                    }
                }, 300);
            }
        }
    };
}]);